'use strict';

var Filter = function () {
    return function (input) {
        return Math.abs(input);
    }
};

module.exports = Filter;
